import PreferenceSelectorWrapper from './PreferenceSelectorWrapper';

export default PreferenceSelectorWrapper;
